import React from 'react'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'

import Button from 'components/Button'
import useCart from 'store/CartProvider'
import Cart from 'components/Icons/Cart'
import Close2 from 'components/Icons/Close2'
import CartTrash from 'components/Icons/CartTrash'
import { moveToCart } from 'services/WishlistService'
import { useWishlistContext } from 'store/WishlistContext'

const HeaderWishlistItem = ({ product }) => {
  const { fetchCart } = useCart()
  const { deleteFromWishlist, fetchWishlist } = useWishlistContext()

  const handleMoveToCart = e => {
    moveToCart(product.sku).then(() => {
      fetchWishlist()
      fetchCart()
      toast.success('პროდუქტი გადავიდა კალათაში')
    })
  }

  return (
    <div className="flex items-center gap-3 py-2 border-b border-slate-100 last:border-b-0 pr-2">
      <div className="w-16 h-16 flex-shrink-0">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-contain"
        />
      </div>
      <div className="flex-grow min-w-0">
        <Link to={`/product/${product.slug}`}>
          <h3 className="text-sm font-medium text-slate-700 line-clamp-2 hover:text-[#ff2337]">
            {product.name}
          </h3>
        </Link>
        <div className="flex items-center gap-2 mt-1 text-slate-400 ">
          <p className="text-sm font-bold text-slate-900 mt-1">
            {product.price} ₾
          </p>
          <div className="flex items-center ml-auto gap-4">
            <Button className="pt-1" onClick={handleMoveToCart}>
              <Cart color="#2d3748" height={15} width={15} />
            </Button>
            <Button
              className="pt-1"
              onClick={() => deleteFromWishlist(product.sku)}
            >
              <CartTrash color="#ff2337" height={15} width={15} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderWishlistItem
